import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useTheme } from "../../context/ThemeContext";
import TransliteratedInput from "../common/TransliteratedInput";
import AutoSave from "../common/AutoSave";

const PatientDiagnosisForm = (props) => {
  const { theme, isDarkMode } = useTheme();
  const { initialValues, onSubmit, onBack, isFirstStep, isLastStep, onAutoSave } = props;

  const patientDiagnosisInfo = initialValues.patientDiagnosis?.[0] || {};

  const formInitialValues = {
    NIDAN_DETAILS: patientDiagnosisInfo?.NIDAN_DETAILS || "",
  };

  const validationSchema = Yup.object().shape({
    NIDAN_DETAILS: Yup.string(),
  });

  return (
    <Formik
      initialValues={formInitialValues}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values);
        setSubmitting(false);
      }}
      enableReinitialize={true}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form className="space-y-6 md:space-y-8 w-full">
          <AutoSave onAutoSave={(values) => (onAutoSave || onSubmit)?.(values, { isAutoSave: true })} />
          {/* Diagnosis Note Section */}
          <div className="space-y-2">
            <label
              htmlFor="NIDAN_DETAILS"
              className="block text-sm font-medium transition-colors"
              style={{ color: theme.text }}
            >
              Nidan Details (Diagnosis Note)
            </label>
            <Field name="NIDAN_DETAILS">
              {({ field, form }) => (
                <TransliteratedInput
                  {...field}
                  onChangeText={(text) => form.setFieldValue(field.name, text)}
                  className="w-full px-4 py-2.5 rounded-lg border transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-opacity-50"
                  style={{
                    backgroundColor: theme.inputBg,
                    borderColor: theme.border,
                    color: theme.text,
                  }}
                  as="textarea"
                  rows={6}
                  placeholder="Enter additional diagnosis observations..."
                />
              )}
            </Field>
            <ErrorMessage name="NIDAN_DETAILS" component="div" className="text-red-500 text-sm mt-1" />
          </div>

          {/* Navigation Buttons */}
          <div
            className="flex justify-between items-center pt-4 mt-8 border-t sticky bottom-0 z-[100] py-4 -mx-4 md:-mx-10 lg:-mx-12 px-4 md:px-10 lg:px-12"
            style={{
              borderColor: theme.border,
              backgroundColor: theme.card,
              boxShadow: '0 -10px 20px rgba(0,0,0,0.05)'
            }}
          >
            {!isFirstStep && onBack && (
              <button
                type="button"
                onClick={onBack}
                className="px-6 py-2 rounded-full font-semibold transition-all duration-200 hover:scale-105 active:scale-95 text-sm"
                style={{
                  backgroundColor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
                  color: theme.text,
                  border: `1px solid ${theme.border}`
                }}
              >
                Back
              </button>
            )}
            <div className={isFirstStep ? "ml-auto" : ""}>
              <button
                type="submit"
                disabled={isSubmitting}
                className="px-8 py-2.5 rounded-full font-bold text-white transition-all duration-200 hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed text-sm md:text-base shadow-lg animate-flow"
                style={{
                  backgroundImage: `linear-gradient(to right, ${theme.brownTwo}, ${theme.secondary}, ${theme.primary}, ${theme.brownTwo})`,
                }}
              >
                {isLastStep ? "Submit" : "Next"}
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default PatientDiagnosisForm;

